import { render, staticRenderFns } from "./VFinance.vue?vue&type=template&id=f61a41e2&"
import script from "./VFinance.vue?vue&type=script&lang=js&"
export * from "./VFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports